import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom-v5-compat";

import Icon from "Atoms/Icons";

import {
  LinkButton,
  ResponsivePrimaryAction,
  ResponsiveTitleBar,
} from "../Atoms";
import { useCustomer } from "../Customer/queries";
import {
  useCurrentCustomerTab,
  useCustomerTab,
  useLoadedCustomerTab,
} from "../CustomerTab/queries";
import Loading, { LoadingPage, isLoading } from "../Loading";
import { useSession } from "../Session/SessionContext";
import { useCurrentBillSplit } from "./queries";

const MissingCustomerTab = () => {
  const { t } = useTranslation();
  return (
    <div className=" text-center max-w-screen-sm mx-auto space-y-64">
      <ResponsiveTitleBar>{t("billSplitError.missingTab")}</ResponsiveTitleBar>
      <div>{t("billSplitError.missingTabDescription")}</div>
      <ResponsivePrimaryAction>
        <LinkButton to="/" primary>
          {t("errors.backToMenu")}
        </LinkButton>
      </ResponsivePrimaryAction>
    </div>
  );
};
const BillSplitLayout = () => {
  const { customerTab } = useSession();
  if (!customerTab) {
    return <MissingCustomerTab />;
  }
  const { status: customerStatus } = useCustomer();
  const { status: billSplitStatus } = useCurrentBillSplit();
  const { status: customerTabStatus } = useCurrentCustomerTab();
  const loading = isLoading([
    customerStatus,
    billSplitStatus,
    customerTabStatus,
  ]);

  return (
    <div className=" pb-64 md:py-24 ">
      {loading ? <LoadingPage /> : <Outlet />}
    </div>
  );
};

export default BillSplitLayout;
